module.exports = __webpack_public_path__ + "img/perspective.a8ffdd09.png";